import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { Inspection, InspectionPlugin } from '../../shared/models/index';

@Component({
    selector: 'inspection-validations',
    templateUrl: './validations.component.html',
    standalone: false
})
export class InspectionValidationComponent implements OnInit {
  @Input() public validatedPlugins: Array<{ data: InspectionPlugin; messages: string[] }> = [];
  @Input() public inspection: Inspection;
  @Output() public toggleCancel: EventEmitter<any> = new EventEmitter();
  constructor() {}

  ngOnInit(): void {}

  public getEditRoute() {
    return ['/inspectionbrowser/inspections', 'this.inspection.id', 'edit'];
  }

  public getBreadcrumbs(plugin: InspectionPlugin): string {
    const breadcrumbs: Array<string> = [];
    breadcrumbs.unshift(plugin.name);

    breadcrumbs.unshift(plugin.inspection.name);
    return breadcrumbs.join(' / '); //'*SPO- Maschine SPO / Customer info';
  }

  public cancel() {
    this.toggleCancel.emit();
  }
}
